var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TheMenuLayout',[_c('PublicCGU')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }